import { localizedMedia } from '../i18n/resources';
import { t } from '../i18n';
import { fetchServices } from '../api/strapi';
import {React, useEffect, useState} from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import InnerModal from "./InnerModal";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import bphoneOriginal from "../img/bphone.png";
import bmailOriginal from "../img/bmail.png";
import bfbOriginal from "../img/bfb.png";
import bisOriginal from "../img/bis.png";
import bytOriginal from "../img/byt.png";

const bphone = localizedMedia(bphoneOriginal, "bphone.png");
const bmail = localizedMedia(bmailOriginal, "bmail.png");
const bfb = localizedMedia(bfbOriginal, "bfb.png");
const bis = localizedMedia(bisOriginal, "bis.png");
const byt = localizedMedia(bytOriginal, "byt.png");

const Contact = () => {
    useEffect(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant',
        });
      }, []);
    //   const onOpenModal = () => setOpen(true);
      const onCloseModal = () => setOpen(false);
      const [open, setOpen] = useState(false);
      const [services, setServices] = useState();
  

      useEffect(()=>{
        fetchServices()
            .then((data) => {
                setServices((data || []).filter(item => item.path && item.garage_category?.path));
            }).catch(() => setServices([]))
    },[])

    return(
        <div>
            <header>
                <Navbar services={services}/>
            </header>
            <Modal open={open} onClose={onCloseModal} center>
                <InnerModal />
            </Modal>
            <section>
                <div className="container contactpage">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="danekontakt-con">
                                <p className="service-desc-par"><b>{t("Soft99 Garage Kupiec Poznański")}</b></p>
                                <p className="service-desc-par">{t("plac Wiosny Ludów 2")}<br />{t("61-831 Poznań")}<br />{t("(poziom -1 parkingu Kupca Poznańskiego)")}</p>
                                <p className="service-desc-par">
                                    <a className="contact-active-link" href="tel:+48607285285"><img className="social-footer-icon" src={bphone} alt=""></img> +48 516 712 233</a><br />
                                    <a className="contact-active-link" href="mailto:kontakt@soft99garage.pl"><img className="social-footer-icon" src={bmail} alt=""></img>{t(" info@myjniasoft99.pl")}</a>
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="mapakontakt-con">
                                <iframe className="mapakontakt" title={t("mapa")} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d274.182281168641!2d16.932584581716178!3d52.40511684004029!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47045b3ed6aa56e7%3A0x194ddb6457cf2173!2sMyjnia%20r%C4%99czna%20Soft99!5e0!3m2!1spl!2spl!4v1781601930354!5m2!1spl!2spl"></iframe>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="danekontakt-con">
                                <p className="service-desc-par"><b>{t("Soft99 Garage Wierzbięcice")}</b></p>
                                <p className="service-desc-par">{t("Wierzbięcice 2A")}<br />{t("61-568 Poznań")}</p>
                                <p className="service-desc-par">
                                    <a className="contact-active-link" href="tel:+48607285285"><img className="social-footer-icon" src={bphone} alt=""></img> +48 607 285 285</a><br />
                                    <a className="contact-active-link" href="mailto:kontakt@soft99garage.pl"><img className="social-footer-icon" src={bmail} alt=""></img>{t(" kontakt@soft99garage.pl")}</a>
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="mapakontakt-con">
                                <iframe className="mapakontakt" title={t("mapa")} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2434.3617570911265!2d16.919403215790222!3d52.40011955285901!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47045b0b68e75319%3A0xac09f3d75a300baa!2sSoft99%20Garage!5e0!3m2!1spl!2spl!4v1652879770662!5m2!1spl!2spl"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Contact;